// src/utils/constants.js

// Local storage keys
export const LOCAL_STORAGE_TOKEN_KEY = 'budget-app-token';
export const LOCAL_STORAGE_PENDING_INVITATION_KEY = 'pending_invitation_token';

// Default messages
export const GENERIC_ERROR_MESSAGE = 'An unexpected error occurred. Please try again later.';

// API-related constants
export const API_REQUEST_TIMEOUT = 10000; // 10 seconds

// Application settings
export const DEFAULT_CURRENCY = 'USD';
export const DEFAULT_LOCALE = 'en-US';